export enum InlineMediaType {
  /**
   * Generic type. Will just display an icon, with no
   * preview.
   */
  File = 'file',
  /**
   * For videos. Will display a media player.
   */
  Video = 'video',
}

const fileTypeToMediaType: Record<string, InlineMediaType> = {
  'video/mp4': InlineMediaType.Video,
  'video/webm': InlineMediaType.Video,
  'video/quicktime': InlineMediaType.Video,
};

/**
 *
 * @param fileType The file type that was retrieved from reading the file.
 * @returns The respective InlineMediaType, which is
 */
export function mediaType(fileType: string) {
  return fileTypeToMediaType[fileType] ?? InlineMediaType.File;
}
